// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"421":"50f721c9","565":"e6aba60c","741":"b4afd645","823":"4f034e44","880":"f7fe9e17","891":"1c35bc3e"}[chunkId] + ".css";
};